module.exports = __webpack_public_path__ + "d6d56297466cb36e143003edddd289fc.jpg";